import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { INVITER_PARAM_KEY } from '@/config/constants/query';

interface AppealTextProps {
  defaultText: string;
  isIncreaseCp: boolean;
}

const AppealText: FC<AppealTextProps> = ({ defaultText, isIncreaseCp }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inviter = queryParams.get(INVITER_PARAM_KEY);

  if (!inviter) {
    return <>{defaultText}</>;
  }
  if (isIncreaseCp) {
    return <>\ 今だけ友だち招待特典増加中！ /</>;
  }
  return <>\ ↓から登録で友だち招待特典ゲット /</>;
};

export default AppealText;
